import React from "react";
import _ from "lodash";
import styled from "styled-components";
import { connect as reduxConnect } from "react-redux";
import { connect } from "formik";
import { compose } from "redux";
import {
  LoanDetailsChildSection,
  AmortizationDetailsChildSection,
  AdditionalAdvancesChildSection,
  ExtensionTermsChildSection,
  ExtensionsChildSection,
  ContactInformationChildSection,
  PrepaymentTermsChildSection,
  ClosingCostsChildSection,
  InsuranceChildSection,
} from "./LoanSectionChildren";
import { SectionTitle } from "./FormSectionComponents";

const VerticalSpacer = styled.div`
  height: 30px;
  display: block;
`;

class LoanSection extends React.Component {
  addContact = contact => {
    const { formik } = this.props;
    const { values } = formik;
    const { loanContacts } = values;
    const newLoanContacts = [...loanContacts];
    newLoanContacts.push(contact);
    formik.setFieldValue("loanContacts", newLoanContacts);
  };

  removeContact = contactId => {
    const { formik } = this.props;
    const { values } = formik;
    const { loanContacts } = values;
    const newLoanContacts = [...loanContacts];
    const index = _.findIndex(newLoanContacts, function(o) {
      return o.contact.id == contactId;
    });
    if (index != -1) {
      newLoanContacts.splice(index, 1);
    }
    formik.setFieldValue("loanContacts", newLoanContacts);
  };

  render() {
    const { formik, isEditing, isQuote, isPassedLoan, guestPermissions, deal } = this.props;
    return (
      <>
        <SectionTitle id="loan_section">General Information</SectionTitle>
        <LoanDetailsChildSection isEditing={isEditing} isQuote={isQuote} isPassedLoan={isPassedLoan} guestPermissions={guestPermissions} deal={deal} />
        {!isPassedLoan && (
          <>
            <VerticalSpacer />
            <AmortizationDetailsChildSection isEditing={isEditing} isQuote={isQuote} />
            <VerticalSpacer />
            <AdditionalAdvancesChildSection formik={formik} isEditing={isEditing} isQuote={isQuote} />
            <VerticalSpacer />
            <InsuranceChildSection isEditing={isEditing} isQuote={isQuote} />
            <VerticalSpacer />
            <ExtensionsChildSection formik={formik} isEditing={isEditing} isQuote={isQuote} />
            <ExtensionTermsChildSection isEditing={isEditing} isQuote={isQuote} />
            <VerticalSpacer />
            <PrepaymentTermsChildSection loanId={this.props.loanId} isEditing={isEditing} isQuote={isQuote} />
            <VerticalSpacer />
            <ClosingCostsChildSection
              brokerList={_.get(formik.values, "ancillary.brokers", [])}
              borrowerCounselList={_.get(formik.values, "ancillary.borrowerCounsels", [])}
              lenderCounselList={_.get(formik.values, "ancillary.lenderCounsels", [])}
              isEditing={isEditing}
              isQuote={isQuote}
            />
            <VerticalSpacer />
            <ContactInformationChildSection
              loanId={this.props.loanId}
              onAddContact={this.addContact}
              onRemoveContact={this.removeContact}
              companyTypes={_.get(formik.values, "ancillary.companyTypes", [])}
              isEditing={isEditing}
              isQuote={isQuote}
            />
            <VerticalSpacer />
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = () => ({});

export default compose(connect, reduxConnect(mapStateToProps, {}))(LoanSection);
